import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as i}from"../../icon-registry.js";const e=i("google",t`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M22.0002 12.3947C22.0002 11.722 21.9406 11.0835 21.8384 10.4619H12.2173V14.3018H17.726C17.4791 15.562 16.7554 16.6262 15.6826 17.35V19.9042H18.9691C20.8933 18.1247 22.0002 15.5024 22.0002 12.3947Z"
                fill="white"
            />
            <path
                d="M12.2159 22.3816C14.9746 22.3816 17.2819 21.4621 18.9678 19.904L15.6812 17.3497C14.7617 17.9627 13.5953 18.3373 12.2159 18.3373C9.55098 18.3373 7.2947 16.5408 6.48585 14.1143H3.09717V16.7452C4.77448 20.0828 8.22275 22.3816 12.2159 22.3816Z"
                fill="white"
            />
            <path
                d="M6.48702 14.1183C6.27416 13.5053 6.16347 12.8497 6.16347 12.1686C6.16347 11.4874 6.28267 10.8318 6.48702 10.2188V7.58789H3.09834C2.40017 8.9672 2 10.5168 2 12.1686C2 13.8203 2.40017 15.3699 3.09834 16.7492L6.48702 14.1183Z"
                fill="white"
            />
            <path
                d="M12.2159 5.9974C13.723 5.9974 15.0682 6.51677 16.1325 7.52997L19.0444 4.61809C17.2819 2.96632 14.9746 1.95312 12.2159 1.95312C8.22275 1.95312 4.77448 4.25198 3.09717 7.58957L6.48585 10.2205C7.2947 7.79391 9.55098 5.9974 12.2159 5.9974Z"
                fill="white"
            />
        </svg>
    `);export{e as Google};
